// 马拉松 默认 顶部菜单

module.exports = {
  sportType: 'marathon',
  menuData: [
    {
      name: 'webMenu',
      arr: [
        {
          name: '数据分析',
          key: 'dataAnalyse',
          routeName: 'marathonDataAnalyseIndex_Hengqin',
          act: false,
        },
        {
          name: '报名数据',
          key: 'signup',
          routeName: 'marathonSignupIndex_Hengqin',
          act: true,
        },
        {
          name: '赛时成绩',
          key: 'gamesTimeResults',
          routeName: 'marathonGamesTimeResultsIndex_Hengqin',
          act: false,
        },
        {
          name: '直播监看',
          key: 'liveMonitoring',
          routeName: 'marathonLiveMonitoringIndex_Hengqin',
          act: false,
        },
        {
          name: '视频切片',
          key: 'videoSection',
          routeName: 'marathonVideoSection',
          act: false,
          child: [
            {
              name: '摄像机位',
              key: 'camera',
              act: false,
              routeName: 'marathonVideoSectionCameraIndex_Hengqin',
            },
            {
              name: '运动员切片',
              key: 'player',
              act: false,
              routeName: 'marathonVideoSectionPlayerIndex_Hengqin',
            },
          ],
        },
        {
          name: '视频集锦',
          key: 'videoCollection',
          routeName: 'marathonVideoCollection',
          act: false,
          child: [
            {
              name: '集锦设置',
              key: 'setting',
              act: false,
              routeName: 'marathonVideoCollectionSettingIndex_Hengqin',
            },
            {
              name: '运动员集锦',
              key: 'player',
              act: false,
              routeName: 'marathonVideoCollectionPlayerIndex_Hengqin',
            },
          ],
        },
      ],
    },
    {
      name: 'openMenu',
      arr: [
        {
          name: '节目单',
          key: 'programList',
          routeName: 'marathonProgramListIndex_Hengqin',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '播出单',
          key: 'broadcastList',
          routeName: 'marathonBroadcastListIndex_Hengqin',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '数据包装',
          key: 'dataPackagList',
          routeName: 'marathonDataPackagListIndex_Hengqin',
          act: false,
          isOpenWeb: true,
        },
      ],
    },
  ],
}
